import 'lazysizes'
import Breakpoint from 'bootstrap-breakpoints'
import * as lib from './lib/lib'
import IsInViewport from './modules/IsInViewport'
import Hero from './modules/Hero'
import Footer from './modules/Footer'
import Newsletter from './modules/Newsletter'
import Menu from './modules/Menu'
import Promo from './modules/Promo'
import { lazyImages } from './modules/LazyImages'
import PasswordToggler from './modules/PasswordToggler'
import ModalBannerSplit from './modules/ModalBannerSplit'
import ModalBannerSolo from './modules/ModalBannerSolo'
import WorkFlow from './modules/WorkFlow'
import Video from './modules/Video'
import AnchorTo from './modules/AnchorTo'
import TableResponsive from './modules/TableResponsive'
import Sitemap from './modules/Sitemap'
import IframeResponsive from './modules/IframeResponsive'
import OffersNav from './modules/OffersNav'
import ToggleContent from './modules/ToggleContent'
import GroupCarousel from './modules/GroupCarousel'
import FeaturesSummary from './modules/FeaturesSummary'
import SolutionsBenefits from './modules/SolutionsBenefits'
import SolutionsHero from './modules/SolutionsHero'
import MyBookingsTables from './modules/MyBookingsTables'
import './modules/MyBookings'
import SolutionsCarousel from './modules/SolutionsCarousel'
import ContentReadMore from './modules/ContentReadMore'
import VehicleTabs from './modules/VehicleTabs'
import Dropdowns from './modules/Dropdowns'
import DropdownsMobile from './modules/DropdownsMobile'
import Headlines from './modules/Headlines'
import LeasingContact from './modules/LeasingContact'
import StickyOnScroll from './modules/StickyOnScroll'
import VehicleFeaturesSlick from './modules/VehicleFeaturesSlick'

window.onYouTubeIframeAPIReady = () => {
  document.dispatchEvent(new Event('on-youtube-iframe-api-ready'))
}

document.onreadystatechange = () => {
  if (document.readyState === 'complete') {
    // document is ready. Do your stuff here

    lib.iniTooltips(document)

    Breakpoint.init()

    lazyImages()

    PasswordToggler()

    new ModalBannerSplit()

    new ModalBannerSolo()

    new WorkFlow()

    new Hero(document.querySelector('.s-hero-v2'))

    new Menu()

    new Footer(document.querySelector('.s-footer'))

    new Newsletter(document.querySelector('.s-newsletter'))

    document.querySelectorAll('.in-viewport').forEach((i) => {
      new IsInViewport(i)
    })

    document.querySelectorAll('.b-promo').forEach((i) => {
      new Promo(i)
    })

    document.querySelectorAll('.b-video').forEach((i) => {
      new Video(i)
    })

    document.querySelectorAll('.js-anchor-to').forEach((i) => {
      new AnchorTo(i)
    })

    document.querySelectorAll('.b-accordion-faq').forEach((i) => {
      new Dropdowns(i)
    })

    document.querySelectorAll('.b-mob-accordion').forEach((i) => {
      new DropdownsMobile(i)
    })

    document.querySelectorAll('.b-article table').forEach((i) => {
      new TableResponsive(i)
    })

    document.querySelectorAll('.b-article iframe').forEach((i) => {
      new IframeResponsive(i)
    })

    document.querySelectorAll('.s-offers-nav').forEach((i) => {
      new OffersNav(i)
    })

    new Sitemap(document.querySelector('.s-sitemap'))

    new ToggleContent()

    new GroupCarousel(document.querySelector('.s-group-carousel'))

    new FeaturesSummary(document.querySelector('.s-features-summary'))

    new SolutionsBenefits(document.querySelector('.s-solutions-benefits'))

    new SolutionsHero(document.querySelector('.s-solutions-hero'))

    new MyBookingsTables(document.querySelector('.s-bookings'))

    new SolutionsCarousel(document.querySelector('.s-solutions-carousel'))

    document.querySelectorAll('.b-content-read-more').forEach((i) => {
      new ContentReadMore(i)
    })

    document.querySelectorAll('.b-accordion:not(.doNotInit)').forEach((i) => {
      new Dropdowns(i)
    })

    document.querySelectorAll('.s-vehicle-tabs').forEach((i) => {
      new VehicleTabs(i)
    })

    new Headlines(document.querySelector('.s-headlines'))

    new StickyOnScroll(
      document.querySelector('.sticky-element'),
      document.querySelector('.sticky-threshold')
    )

    new LeasingContact(document.querySelector('.b-contact-wdgt'))

    new VehicleFeaturesSlick(
      document.querySelector('.s-vehicle-features-slick')
    )

    if (
      document.querySelectorAll('.b-video').length ||
      document.getElementById('app-videos-slick')
    ) {
      // 2. This code loads the IFrame Player API code asynchronously.
      const tag = document.createElement('script')

      tag.src = 'https://www.youtube.com/iframe_api'
      const firstScriptTag = document.getElementsByTagName('script')[0]
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
    }
  }
}
